import type { FC } from 'react'
import { memo } from 'react'

import { ModalContextConsumer } from './ModalContext'

export interface IModalRootProps {}

export const ModalRoot: FC<IModalRootProps> = memo((props) => {
  return (
    <ModalContextConsumer>
      {({ component: Component, componentProps, hideModal }) =>
        Component ? (
          <Component onDismiss={hideModal} {...componentProps} />
        ) : null
      }
    </ModalContextConsumer>
  )
})

ModalRoot.displayName = 'ModalRoot'
